/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */

export type ReadinessGap = (typeof ReadinessGap)[keyof typeof ReadinessGap];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReadinessGap = {
  MISSING_DATES: "MISSING_DATES",
  OUTSIDE_PHASE: "OUTSIDE_PHASE",
  UNASSIGNED_TASKS: "UNASSIGNED_TASKS",
  NO_TASKS: "NO_TASKS",
  NO_CHECKPOINTS: "NO_CHECKPOINTS",
  MISSING_CRITICALITY: "MISSING_CRITICALITY",
} as const;
